import { useEffect } from "react";

import { BookingAnalyticsEvent } from "@/constants/analytics/Analytics";
import { TabPath } from "@/constants/Navigation";
import { ConfirmationAlertTestID } from "@/constants/TestID";
import { router } from "@/crossPlatform/expo-router";
import useBookingAnalytics from "@/hooks/useBookingAnalytics";
import { useAppSelector } from "@/store/hooks";
import {
  selectIsConfirmationAlertOpen,
  useBookingDispatch,
} from "@/store/reducers/booking";
import ConfirmationAlert from "@/ui/composed/alerts/ConfirmationAlert";
import { FAIconName } from "@/ui/core";

const AppointmentConfirmationAlert = () => {
  const isAlertOpen = useAppSelector(selectIsConfirmationAlertOpen);
  const { closeConfirmationAlert } = useBookingDispatch();

  const { trackAlertEvent, trackAlertView } = useBookingAnalytics();

  const alertType: BookingAlertType = "success";

  const handleConfirm = () => {
    closeConfirmationAlert();
    router.navigate(TabPath.Schedule);
    trackAlertEvent({
      event: BookingAnalyticsEvent.ViewSchedule,
      source: alertType,
    });
  };

  const handleDismiss = () => {
    closeConfirmationAlert();
    trackAlertEvent({
      event: BookingAnalyticsEvent.Close,
      source: alertType,
    });
  };

  useEffect(() => {
    if (isAlertOpen) {
      trackAlertView(alertType);
    }
  }, [isAlertOpen, trackAlertView]);

  return (
    <ConfirmationAlert
      confirmationType="neutral"
      confirmLeftIcon={FAIconName.Calendar}
      confirmText="View schedule"
      isOpen={isAlertOpen}
      message="You can view and manage your appointments in the Schedule tab."
      onConfirm={handleConfirm}
      onDismiss={handleDismiss}
      testID={ConfirmationAlertTestID.BookingSuccess}
      title="Appointment scheduled"
    />
  );
};

export default AppointmentConfirmationAlert;
